/**
 * Phone fields formatting library.
 */
(function($) {
  var numberFormats = {
    en_US: {
      format: '(000) 000-0000',
    },
    en_AU: {
      format: '00 0000 0000',
    },
    fallback: {
      format: '',
    }
  };

  /**
   * Get format for the current country.
   * @return {*}
   */
  var getFormat = function () {
    var country = !window.ACC ? '' : window.ACC.languageISO;
    return country in numberFormats ? numberFormats[country] : numberFormats.fallback;
  };

  /**
   * Init phone fields by given selector(s).
   * @param selector
   */
  function init(selector) {
    var $elements = $(selector);
    if (!$elements || !$elements.length) {
      return;
    }

    var format = getFormat().format;
    if (format) {
      $elements.mask(format);
    }
  };

  $(function() {
    window.addEventListener('trek:format.phone.field', () => {
      init('.phone-field');
    });

    init('.phone-field');
  });
})(jQuery);
